export const convertArrayToHashMapByKey = (array, key) => {
  const resultHashMap = {}

  if (!Array.isArray(array)) return resultHashMap

  array.forEach((item) => {
    resultHashMap[item[key]] = item
  })

  return resultHashMap
}
